<template>
    <div class="login_bg">

    <v-container>
        <div class="login_box">
            <div class="login_left">

            </div>
            <div class="login_right">

                <v-form @submit.prevent="submitLogin">
                    <div class="login_title">
                        <h1>
                            LOGIN
                        </h1>
                    </div>
                    <v-text-field v-model="email" label="이메일" color="black" prepend-inner-icon="mdi-email" :rules="emailRules"/>

                    <v-text-field v-model="password" label="암호" color="black" prepend-inner-icon="mdi-lock"
                        type="password" :rules="passwordRules"/>

                    <v-btn type="submit" color="#007bff" depressed large block class="mb-2 mt-1" dark>
                        로그인
                    </v-btn>
                    <FindPasswordForm />
                </v-form>

                <AppConfirmDialog v-model="showConfirmationDialog" :title="confirmationTitle"
                    :message="confirmationMessage" @confirm="handleConfirm" />
            </div>
        </div>
        
        <!-- <v-layout align-center row wrap>
            <v-flex xs12>
                <v-card class="pa-10">
                    <div class="mb-5" style="display: grid;justify-content: center;">
                        <h1>VIDEO CMS</h1>
                        <span style="color: #aaa;">StreamOn</span>
                        <v-img :src="require('@/styles/vodlove_videocms logo_login.png')" width="260px"/> 
                    </div>
                    
                    <v-form @submit.prevent="submitLogin">
                        <v-text-field v-model="email" label="이메일" color="black" prepend-inner-icon="mdi-email" />

                        <v-text-field v-model="password" label="암호" color="black" prepend-inner-icon="mdi-lock"
                            type="password" />

                        <v-btn type="submit" color="black lighten-1 text-capitalize" depressed large block class="mb-2"
                            dark>
                            로그인
                    </v-btn>

                    </v-form>

                    <FindPasswordForm />

                    <AppConfirmDialog v-model="showConfirmationDialog" :title="confirmationTitle"
                        :message="confirmationMessage" @confirm="handleConfirm" />

                </v-card>
            </v-flex>

        </v-layout> -->
    </v-container>
</div>
</template>

<script>
import FindPasswordForm from '@/components/user/FindPasswordForm.vue';
import { mapActions } from 'vuex';
import AppConfirmDialog from '@/components/app/AppConfirmDialog.vue';
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';



export default {
    components: {
        TextButtonBlock,
    },
    data() {
        return {
            email: '',
            emailRules: [
                v => !v || /.+@.+\..+/.test(v) || '이메일 주소를 정확히 입력해주세요.',
                // 이메일 형태 미기입시 뜨는 오류 힌트
            ],
            password: '',
            passwordRules: [
                v => !v || /[!@#$%^&*(),.?":{}|<>]/.test(v) || '영문, 숫자, 특수문자를 조합하여 입력해주세요. ',
                // 특수기호 미입력시 뜨는 오류 힌트
            ],
            showConfirmationDialog: false,
            confirmationTitle: '',
            confirmationMessage: '',
        };
    },
    components: {
        FindPasswordForm,
        AppConfirmDialog
    },
    methods: {
        ...mapActions('user', ['login']),
        submitLogin() {
            this.login({ email: this.email, password: this.password })
                .then((data) => {
                    this.$router.push({ path: '/dashboard' });
                })
                .catch(error => {
                    //console.error('error:', error);
                    this.confirmationTitle = "로그인 실패";
                    this.confirmationMessage = error.response && error.response.data.message
                        ? error.response.data.message
                        : "로그인 과정에서 오류가 발생했습니다. 다시 시도해 주세요.";
                    this.showConfirmationDialog = true;
                });
        },
        handleConfirm() {
            this.showConfirmationDialog = false;
            this.email = '';
            this.password = '';
        },
    }
};
</script>

<style scoped>
.login_bg {
    background-image: url(./../../styles/login_background.png);
    background-size: cover;
    height: 100%;
    display: flex;
    justify-content: center; /* 수평 가운데 정렬 */
    align-items: center;
}
.login_box {
    display: flex;
    justify-content: center; /* 수평 가운데 정렬 */
    align-items: center;
    height: 500px;
}

.login_title{
    color: #007bff;
}

.login_left{
    width: 530px;
    height: 500px;
    background-image: url(./../../styles/login_left_graphic.png);
    border-radius: 10px 0 0 10px;
}

.login_right{
    width: 320px;
    height: 500px;
    background: #fff;
    padding: 36px;
    display: grid;
    justify-content: center;
    align-items: center;
    border-radius: 0px 10px 10px 0px;
}

@media only screen and (max-width: 780px) {
    .login_title{justify-content: center;display: flex;}
    .login_left {display: none;}
    .login_right {border-radius: 10px;width: 360px;}
}
</style>
